var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicCrud',{attrs:{"fields":_vm.fields,"title":_vm.$t('Units'),"path":"unit","boolColumns":_vm.boolColumns,"hideEditAction":!_vm.isMaster(),"hideDeleteAction":!_vm.isMaster(),"showNewButton":_vm.isMaster()}})}
var staticRenderFns = []

export { render, staticRenderFns }